// eslint-disable-next-line no-restricted-imports
import { Button as AntButton, ButtonProps } from 'antd';

export const Button = (props: ButtonProps) => {
    return <AntButton {...props} />;
};
